import { ExportSingleQuestionFormat, QuestionStatus } from '@exam-management/graphql';

export { ExportSingleQuestionFormat };

export enum QuestionExportFileTemplate {
  QUESTION_WITH_CHOICES = 'QUESTION_WITH_CHOICES',
  QUESTION_WITH_CHOICES_AND_SOLUTION = 'QUESTION_WITH_CHOICES_AND_SOLUTION',
}

export const PUBLISHABLE_ITEM_SET_SUB_QUESTION_STATUSES = [
  QuestionStatus.Draft,
  QuestionStatus.Unpublished,
];

export const QUESTION_EXPORT_FILE_TYPE_OPTIONS = [
  {
    label: 'PDF (.pdf)',
    value: ExportSingleQuestionFormat.Pdf,
  },
  {
    label: 'Microsoft Word (.docx)',
    value: ExportSingleQuestionFormat.Docx,
  },
];

export const QUESTION_EXPORT_FILE_TEMPLATE_OPTIONS = [
  {
    label: 'โจทย์, ตัวเลือก',
    value: QuestionExportFileTemplate.QUESTION_WITH_CHOICES,
  },
  {
    label: 'โจทย์, ตัวเลือก, และเฉลย',
    value: QuestionExportFileTemplate.QUESTION_WITH_CHOICES_AND_SOLUTION,
  },
];
